<template>
  <div class="page">
    <div class="box f v fvc">
      <img
        src="https://j.weizan.cn/youxiang/check-success.png"
        class="status-img"
      />
      <div class="tip" v-if="verifyType == 'loading'">核销中</div>
      <div class="tip" v-if="verifyType == 'fail'">核销失败</div>
      <div class="tip" v-if="verifyType == 'success'">核销成功</div>
    </div>

    <div class="f v fvc">
      <div class="back-btn" @click="backHome">返回首页</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      userId: 0,
      verifyType: "loading",
    };
  },
  async created() {
    this.act_id = this.$route.query.act_id || localStorage.getItem("act_id");
    if (this.$route.query.addition) {
      // 获取逛店用户的id
      var jsondetail = decodeURIComponent(this.$route.query.addition);
      var userId = JSON.parse(jsondetail).user_id;
      this.userId = userId || this.$route.query.userid || this.$route.query.userId ;//二维码url中获取而不是addition中获取
      console.log(this.$route.query.addition);
      this.verifyGoShop();
    } else {
      this.$toast("该二维码无效，请核对");
      this.verifyType = "fail";
      setTimeout(() => {
        this.$router.push({
          path: "/kpi",
          query: {
            act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
          },
        });
      }, 2000);
    }
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    backHome() {
      let tmp = localStorage.getItem("preheatPath") || "prehddd";
      this.$router.push({
        path: tmp,
        query: {
          act_id: this.$route.query.act_id || localStorage.getItem("act_id"),
        },
      });
    },
    // 核销逛店
    async verifyGoShop() {
      let res = await this.$http.post(`/v1/apply/go_shop`, {
        userId: this.userId,
      });
      console.log(res, "核销逛店结果");
      if (res.data && res.code == 0) {
        // 此处进行核销结果操作
        this.verifyType = "success";
        setTimeout(() => {
          this.$router.push({
            path: "/kpi",
            query: {
              act_id:
                this.$route.query.act_id || localStorage.getItem("act_id"),
            },
          });
        }, 5000);
      } else {
        this.verifyType = "fail";
        // this.$toast(res.msg);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background: #f5f6f7;
  .box {
    padding-bottom: 80px;
    .tip {
      font-size: 14px;
    }
  }
  .back-btn {
    width: 133px;
    height: 44px;
    border: 1px solid rgba(0, 48, 120, 1);
    border-radius: 22px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(0, 48, 120, 1);
    line-height: 44px;
    text-align: center;
    position: fixed;
    bottom: 25px;
  }
  .status-img {
    width: 88px;
    height: 88px;
    margin: 80px 0 20px;
  }
}
</style>